import { assign } from 'xstate';

import { FlowContextSme } from '../context';
import { energyTypeIncludes } from '../helpers';
import { EnergyType } from '../types';

const resetValues = (energyType: EnergyType): FlowContextSme => {
  const data: FlowContextSme = {};

  data.offerType = undefined;

  if (!energyTypeIncludes(energyType, EnergyType.Electricity)) {
    data.hasDoubleMeter = undefined;

    data.usageElectricityHigh = undefined;
    data.usageElectricityLow = undefined;

    data.hasSolarPanels = undefined;
    data.solarPanelsOutput = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.Gas)) {
    data.usageGas = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.Warmth)) {
    data.usageWarmth = undefined;
  }

  if (!energyTypeIncludes(energyType, EnergyType.TapWater)) {
    data.usageWater = undefined;
  }

  return data;
};

export const resetUsageValues = assign(({ context, event }) => {
  if ('values' in event) {
    const energyType = event?.values?.energyType ?? context.energyType ?? EnergyType.Electricity;

    const values = {
      ...context,
      ...resetValues(energyType),
    };

    return values;
  }
});
